import Header from "../Components/Header";
import Card from "../Components/Card";
import { BRAND } from "../css/brand";
import BlueButton from "../Components/BlueButton";

export default function Support() {
  return (
    <div className="space-y-3 sm:space-y-4">
      <Header  brand={BRAND} title="Support Tickets" />
      <Card brand={BRAND} title="Raise a Ticket">
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
          <select className="rounded-lg border px-3 py-2 text-sm"><option>Key Issue</option><option>Payment Issue</option><option>Inventory Issue</option><option>Other</option></select>
          <input placeholder="Subject" className="rounded-lg border px-3 py-2 text-sm" />
          <textarea placeholder="Describe the issue" className="sm:col-span-2 min-h-[120px] rounded-lg border px-3 py-2 text-sm" />
          <div className="sm:col-span-2 flex items-center justify-between"><input type="file" className="text-sm" /><BlueButton brand={BRAND}>Submit Ticket</BlueButton></div>
        </div>
      </Card>
    </div>
  );
}
